/**
 * Maps Shopify Colour option display names (any locale) to theme visual families.
 * e.g. Pink / Rose / Poupette → "pink"; Turquoise / Teal / SwoopMan → "teal"
 */
(function (global) {
  'use strict';

  function normalize(name) {
    return String(name == null ? '' : name).toLowerCase().trim();
  }

  function isPinkish(c) {
    return (
      c.indexOf('pink') !== -1 ||
      c.indexOf('rose') !== -1 ||
      c.indexOf('poupette') !== -1 ||
      c.indexOf('magenta') !== -1 ||
      c.indexOf('fuchsia') !== -1
    );
  }

  function isTealish(c) {
    return (
      c.indexOf('turquoise') !== -1 ||
      c.indexOf('teal') !== -1 ||
      c.indexOf('swoopman') !== -1 ||
      c.indexOf('cyan') !== -1
    );
  }

  function family(name) {
    var c = normalize(name);
    if (!c) return '';
    if (isTealish(c)) return 'teal';
    if (isPinkish(c)) return 'pink';
    return c.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function familyOrder(name) {
    var fam = family(name);
    if (fam === 'teal') return 0;
    if (fam === 'pink') return 1;
    return 2;
  }

  function sortValues(list) {
    if (!list || !list.length) return [];
    return list.slice().sort(function (a, b) {
      var diff = familyOrder(a) - familyOrder(b);
      if (diff !== 0) return diff;
      return String(a).localeCompare(String(b));
    });
  }

  /** CSS / data-attribute key used by cart upsells and bag card images */
  function themeKey(name) {
    var fam = family(name);
    if (fam === 'teal') return 'turquoise';
    return fam;
  }

  function match(a, b) {
    var x = normalize(a);
    var y = normalize(b);
    if (!x || !y) return false;
    if (x === y) return true;
    var fx = family(x);
    var fy = family(y);
    return (fx === 'pink' || fx === 'teal') && fx === fy;
  }

  function findInList(list, target) {
    if (!list || !list.length || !target) return -1;
    var y = normalize(target);
    for (var i = 0; i < list.length; i++) {
      if (match(list[i], y)) return i;
    }
    return -1;
  }

  global.SwoopColor = {
    normalize: normalize,
    family: family,
    familyOrder: familyOrder,
    sortValues: sortValues,
    themeKey: themeKey,
    match: match,
    findInList: findInList,
  };
})(typeof window !== 'undefined' ? window : this);
